import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import AiAssistantModal from "../components/AiAssistantModal";
import AiImg from "../assets/images/ai-img.png";

interface MainLayoutProps {
  children?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [isAiOpen, setIsAiOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#F9FAFB]">
      <Sidebar />
      <div className="flex-1 flex flex-col md:ml-[250px] min-h-screen">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
        <Footer />
      </div>
      <button
        type="button"
        onClick={() => setIsAiOpen(true)}
        className="fixed -bottom-4 -right-4 z-50 cursor-pointer hover:scale-110 transition-transform m-3"
      >
        <img
          src={AiImg}
          alt="AI Assistant"
          className="w-32 h-32 object-contain drop-shadow-lg"
        />
      </button>
      <AiAssistantModal isOpen={isAiOpen} onClose={() => setIsAiOpen(false)} />
    </div>
  );
};

export default MainLayout;
